import { IStoreState } from '../../types'
import { getCurrentOrganization } from '../../state/reducers/organizations'
import { connect } from 'react-redux'
import RouteWithMenu from '../../components/navigation/RouteWithMenu'
import { RouteProps } from 'react-router'

const mapStateToProps = (state: IStoreState, ownProps: RouteProps) => {
  const isAdmin = state.authorization.type === ''
  return {
    currentOrganization: getCurrentOrganization(state),
    isAdmin,
    routeProps: ownProps
  }
}

export default connect(mapStateToProps)(RouteWithMenu)



// WEBPACK FOOTER //
// ./src/containers/navigation/RouteWithMenu.ts